<template>
  <WsMain>
    <WsBreadCrumbs :items="breadcrumbsItems" class="mb-3"></WsBreadCrumbs>
    <WsStateInput
      autofocus
      type="text"
      placeholder="請輸入測試用的 api 網域"
      :value="route"
      class="mb-3"
      @input="route = $event"
    />
    <WsStateInput
      autofocus
      type="text"
      placeholder="請輸入測試用的 token"
      :value="token"
      class="mb-3"
      @input="token = $event"
    />
    <WsFlex class="justify-space-between mb-3">
      <WsBtn
        :loading="isLoading.data"
        :disabled="!token || !route"
        class="ml-2"
        @click="$_onFetch()"
      >
        <div>Fetch Data</div>
      </WsBtn>
      <span class="mr-4">剩餘同步數量{{remainCount}}</span>
    </WsFlex>
    <WsDataTable
      :items="dataList"
      :fields="fields"
      :headers="headers"
      :itemsPerPage="15"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :loading="isLoading.data"
      :isPaginationShow="false"
      :displayFields="displayFields"
      class="mb-20"
    >
      <template v-slot:expanded="{item}">
        <div :style="{width: '850px'}">
          <pre >{{ item.all }}</pre>
        </div>
      </template>
    </WsDataTable>
  </WsMain>
</template>

<script>
import model from "@/models/subscriptionApiDemo";

export default {
  data() {
    return {
      isLoading: {
        data: false,
      },
      isStart: true,
      dataList: [],
      remainCount: 0,
      breadcrumbsItems: [{
        text: "訂閱 API DEMO",
        to: "/subscription_api_demo",
        disabled: false,
      }],
      headers: model.read.headers,
      fields: model.read.fields,
      displayFields: model.read.displayFields,
      route: "",
      token: "",
    };
  },
  computed: {
    _currentModuleVal() {
      return this.$route.params.moduleVal;
    },
  },
  mounted() {
    this.$_getBreadcrumbsItems();
  },
  methods: {
    async $_onFetch() {
      if (!this.route || !this.token) return;
      this.isLoading.data = true;
      const specialAxios = this.$axios.create({
        baseURL: this.route,
        headers: {
          Authorization: this.token,
        },
      });
      try {
        const res = await specialAxios.get("/api/sub/sync/test/act");
        if (res.status >= 500) alert("status code : 5開頭,500、504,請儘速聯絡律盟人員");
        else if (res.data.message) {
          alert(res.data.message);
          this.dataList = [];
        } else {
          this.dataList = [...this.dataList,
            {
              id: res.data.data[0].id,
              name: res.data.data[0].act_version.name,
              all: res.data.data[0],
            }
          ];
          this.remainCount = res.data.meta.total - 1;
        }
        this.isStart = false;
      } catch (err) {
        alert(err.response.data.message);
      } finally{
        this.isLoading.data = false;
      }
    },
    $_getBreadcrumbsItems() {
      this.breadcrumbsItems.push({
        text: model.index.items.find(item => item.value === this._currentModuleVal).module,
        disabled: true,
      });
    },
  },
}
</script>